import icon from "../../../assets/static/images/secciones/bandejaentrada.png";
import ListRegistersLogin from "./Components/ListadoRegistros";

const RegistrosLogin = () => {
  return (
    <div className="section-content inbox-section mesa-judicial">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="bandejaentrada" />
        <span>Registros Login</span>
      </div>
      <ListRegistersLogin />
    </div>
  );
};

export default RegistrosLogin;